module.exports = __webpack_public_path__ + "assets/hongkong.5659a394.svg";